export const PATIENT_MESSAGES_PATH = '/messages';
export const PATIENT_CHAT_PATH = '/chat';

type InboxMenuItem = {
  link: string;
  items?: InboxMenuItem[];
  subMenu?: InboxMenuItem[];
};

export function patientInboxPath(triageAgentEnabled: boolean): string {
  return triageAgentEnabled ? PATIENT_CHAT_PATH : PATIENT_MESSAGES_PATH;
}

export function isPatientMessagesPath(link: string): boolean {
  const path = link.startsWith('/') ? link : `/${link}`;
  return path === PATIENT_MESSAGES_PATH || path.startsWith(`${PATIENT_MESSAGES_PATH}/`);
}

export function rewritePatientInboxLink(
  link: string,
  triageAgentEnabled: boolean
): string {
  if (!triageAgentEnabled || !isPatientMessagesPath(link)) return link;
  const rewritten = (link.startsWith('/') ? link : `/${link}`).replace(
    /^\/messages/,
    PATIENT_CHAT_PATH
  );
  return link.startsWith('/') ? rewritten : rewritten.slice(1);
}

export function rewritePatientInboxMenu<T extends InboxMenuItem>(
  items: T[] | undefined,
  triageAgentEnabled: boolean
): T[] | undefined {
  if (!items || !triageAgentEnabled) return items;
  return items.map((item) => {
    const next: T = {
      ...item,
      link: rewritePatientInboxLink(item.link, true)
    };
    if (item.items) next.items = rewritePatientInboxMenu(item.items, true);
    if (item.subMenu) next.subMenu = rewritePatientInboxMenu(item.subMenu, true);
    return next;
  });
}
